import BranchCard from '../../molecules/BranchCard';
import ArrowSplit from '../../atoms/Icons/ArrowSplit';
import Close from '../../atoms/Close';
import { Loader } from '@googlemaps/js-api-loader';
import React, { useEffect, useState } from 'react';
import { getDistanceBranchData } from '../../../helpers/utils';
import eventDirection from 'ui/lib/gtm/eventDirection';
import Head6 from '../../atoms/Text/Head6';
import useImpressionBranchSales from '../../../hooks/emarsys/branch-sales/useImpressionBranchSales';
import { PAGE_NAME_BRANCH_SALES } from '../../../constants/emarsys/branch-sales';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store';
const API_KEY = process.env.NEXT_PUBLIC_GMAPS_API_KEY;
const MAP_ID = process.env.NEXT_PUBLIC_GMAPS_MAP_ID;

const BranchMapSection = ({
  onClickClose,
  data = [],
  distanceData = [],
  city,
  filteredData = [],
  isClosingStickyFilter = false,
  showBranchList = true,
  mapHeightClassName = 'h-full',
  isHomepage = false,
  pageTitle = '',
  featureName = '',
  breadcrumbItems = [],
  isProvinceReady = true,
  branchProvince = {},
  cityCode = '',
  showWhatsappChat = false,
  isMapView = false,
}: any) => {
  const branchListImpressionRef = React.useRef(null);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const { userLocation: userReduxLocation } = useSelector(
    (state: IRootState) => state.userLocation
  );

  const handleClickDirection = (branchName, province, city, mode) => {
    eventDirection(branchName, province, city, mode);
  };

  // Get user location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setUserLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  }, []);

  useEffect(() => {
    const loader = new Loader({
      apiKey: API_KEY,
      version: 'weekly',
      libraries: ['places'],
    });
    const parser = new DOMParser();
    const pinSvgString = `
      <svg id='red-point-map' xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40" fill="none">
        <path d="M16.0031 19.7192C17.0397 19.7192 17.9259 19.3501 18.6618 18.6119C19.3976 17.8737 19.7655 16.9863 19.7655 15.9496C19.7655 14.913 19.3964 14.0268 18.6582 13.2909C17.92 12.5551 17.0326 12.1872 15.996 12.1872C14.9593 12.1872 14.0731 12.5563 13.3373 13.2945C12.6014 14.0327 12.2335 14.9201 12.2335 15.9567C12.2335 16.9933 12.6026 17.8796 13.3408 18.6154C14.079 19.3512 14.9664 19.7192 16.0031 19.7192ZM15.9995 39.8112C10.7565 35.268 6.82488 31.0399 4.20467 27.127C1.5845 23.2141 0.274414 19.6217 0.274414 16.3498C0.274414 11.5421 1.82957 7.64994 4.93988 4.67317C8.05016 1.69639 11.7367 0.208008 15.9995 0.208008C20.2623 0.208008 23.9489 1.69639 27.0592 4.67317C30.1695 7.64994 31.7246 11.5421 31.7246 16.3498C31.7246 19.6217 30.4145 23.2141 27.7944 27.127C25.1742 31.0399 21.2425 35.268 15.9995 39.8112Z" fill="#CE181E"/>
      </svg>`;
    let map;
    let mapMobile;

    loader.load().then(async () => {
      const { Map } = (await google.maps.importLibrary('maps')) as any;
      const { AdvancedMarkerElement } = (await google.maps.importLibrary('marker')) as any;
      const position = { lat: -6.223924, lng: 106.82687 };
      const mapSettings = {
        center: position,
        zoom: 12,
        mapId: MAP_ID,
        mapTypeControl: false,
      };

      map = new Map(document.getElementById('map'), mapSettings);
      mapMobile = new Map(document.getElementById('map-mobile'), mapSettings);

      if (!(data?.length > 0)) return;
      const availableLatLng = data.find((item) => item?.latitude && item?.longitude);
      const centerToMap = (): { lat: number; lng: number } => {
        if (availableLatLng) {
          return { lat: availableLatLng.latitude, lng: availableLatLng.longitude };
        } else if (userReduxLocation.latitude && userReduxLocation.longitude) {
          return { lat: userReduxLocation.latitude, lng: userReduxLocation.longitude };
        } else {
          return position;
        }
      };
      const latLngFirstBranch = centerToMap();
      map.panTo(latLngFirstBranch);
      mapMobile.panTo(latLngFirstBranch);

      data.forEach((branch) => {
        const pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;
        const pinSvgMobile = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;

        if (branch.latitude && branch.longitude) {
          const marker = new AdvancedMarkerElement({
            map: map,
            content: pinSvg,
            position: { lat: branch.latitude, lng: branch.longitude },
            title: branch.displayName,
          });

          const markerMobile = new AdvancedMarkerElement({
            map: mapMobile,
            content: pinSvgMobile,
            position: { lat: branch.latitude, lng: branch.longitude },
            title: branch.displayName,
          });

          marker.addListener('click', () => {
            setSelectedBranch(branch);
            map.panTo({ lat: branch.latitude, lng: branch.longitude });
          });
          markerMobile.addListener('click', () => {
            setSelectedBranch(branch);
            mapMobile.panTo({ lat: branch.latitude, lng: branch.longitude });
          });
        }
      });
    });
  }, [data]);

  const getDirectionUrl = (branch) => {
    if (!userLocation || !branch) return '#';
    return `https://www.google.com/maps/dir/${userLocation.lat},${userLocation.lng}/${branch.latitude},${branch.longitude}/@${branch.latitude},${branch.longitude},17z?entry=ttu`;
  };

  if (featureName === 'branchList') {
    // For Impression Header
    useImpressionBranchSales({
      firstRef: branchListImpressionRef,
      pageName: PAGE_NAME_BRANCH_SALES.LIST_DEALER_TOYOTA,
      pageTitle: pageTitle,
      breadcrumbItems: breadcrumbItems,
      sectionName: 'dealer list',
      isProvinceReady,
      newParams: {
        province: branchProvince?.name ?? '',
        province_code: branchProvince?.isocode ?? '',
        city: city,
        city_code: cityCode,
        ...(breadcrumbItems?.[2]?.name
          ? {
              menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase(),
            }
          : {}),
      },
    });
  }

  return (
    <section className="lg:mt-0 container xl:px-0">
      <div className={showBranchList ? 'grid grid-cols-2 gap-6 items-start' : 'sticky'}>
        {showBranchList ? (
          <div className="grid grid-cols-2 gap-x-6 gap-y-7" ref={branchListImpressionRef}>
            {filteredData.map((branch, index) => (
              <BranchCard
                key={index}
                index={index}
                data={branch}
                showWhatsappChat={showWhatsappChat}
                distance={getDistanceBranchData(distanceData, branch.id).distanceFormatted}
                city={city}
                branchProvince={branchProvince}
                pageTitle={pageTitle}
                cityCode={cityCode}
                breadcrumbItems={breadcrumbItems}
                isMapView={isMapView}
              />
            ))}
          </div>
        ) : null}

        {/* MAP DESKTOP */}
        <div
          className={`transition-all overflow-y-hidden sticky ${
            isClosingStickyFilter
              ? 'top-[calc(286px-89px)] h-[calc(100vh-310px+89px)]'
              : !isHomepage && 'top-[286px] h-[calc(100vh-310px)]'
          }`}
        >
          <div id="map" className={`${mapHeightClassName} w-full`}></div>
          <div
            className={`absolute ${
              selectedBranch !== null ? 'bottom-5' : '-bottom-72'
            } left-[54px] right-[54px] bg-white p-6 text-center rounded shadow-lg transition-all duration-500`}
          >
            <p className="font-bold text-2xl text-reliableBlack90 uppercase">
              {selectedBranch?.displayName}
            </p>
            <p className="mt-1 text-base">{selectedBranch?.line1}</p>
            <a
              id="direction-plp-desktop"
              onClick={() =>
                handleClickDirection(
                  selectedBranch?.displayName,
                  selectedBranch?.city?.province?.name,
                  selectedBranch?.city?.name,
                  'map'
                )
              }
              href={getDirectionUrl(selectedBranch)}
              target="_blank"
              rel="noopener noreferrer"
              className="w-80 h-[42px] bg-reliableBlack3 flex mx-auto justify-center items-center rounded mt-5 text-hyperLink gap-[5px]"
            >
              <p className="text-xs font-medium">PETUNJUK ARAH</p>
              <ArrowSplit fill="#036EBC" size="24" />
            </a>
            <button
              id="red-point-plp"
              className="text-black absolute top-3 right-3"
              onClick={() => setSelectedBranch(null)}
              aria-label="close button"
            >
              <Close fill="#231F20" size={28} />
            </button>
          </div>
        </div>
      </div>

      {/* MAP MOBILE */}
      <div
        className={`fixed flex-col z-[70] top-0 left-0 flex items-center justify-center w-full h-screen bg-white min-h-screen ${isHomepage ? 'hidden' : 'lg:hidden'}`}
      >
        <div className="flex w-full justify-between px-4 py-6 border-b border-b-reliableBlack30">
          <Head6 as={isHomepage ? 'p' : 'h6'} className="font-bold text-reliableBlack90 uppercase">
            AUTO2000 {city}
          </Head6>
          <button className="text-black" aria-label="close-button" onClick={onClickClose}>
            <Close fill="#231F20" size={24} />
          </button>
        </div>
        <div className="overflow-y-auto h-full w-full">
          <div className="row-span-2 w-full h-full" id="map-mobile"></div>
        </div>
        {selectedBranch !== null && (
          <div className="flex flex-col w-full justify-between px-4 py-6 border-t border-t-reliableBlack30">
            <Head6
              as={isHomepage ? 'p' : 'h6'}
              className="font-bold text-reliableBlack90 uppercase"
            >
              {selectedBranch.displayName}
            </Head6>
            <p className="text-xs font-medium leading-relaxed text-reliableBlack mb-5 lg:text-base">
              {selectedBranch.line1}
            </p>
            <a
              id="direction-plp-mobile"
              onClick={() =>
                handleClickDirection(
                  selectedBranch?.displayName,
                  selectedBranch?.city?.province?.name,
                  selectedBranch?.city?.name,
                  'map'
                )
              }
              href={getDirectionUrl(selectedBranch)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-black bg-reliableBlack10 flex items-center justify-center py-4 gap-[5px]"
            >
              <ArrowSplit fill="#036EBC" size={24} />
              <p className="text-sm font-medium text-hyperLink">Petunjuk Arah</p>
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default BranchMapSection;
